import React, { useMemo, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import Modal from '@ublique/components/Modal'
import { size } from 'lodash'

import './index.scss'

function DeletingScenarioModal({ open, close, data }) {
  const { onSubmit, selectedRows, selectAll } = data
  const { t } = useTranslation(['Scenario', 'Wizard'])

  const confirmationMsg = useMemo(() => {
    return selectAll
      ? t('Scenario.DELETE_ALL_SCENARIOS')
      : size(selectedRows) > 1
      ? t('Scenario.DELETE_SCENARIOS')
      : t('Scenario.DELETE_SCENARIO')
  }, [selectedRows, selectAll])

  const onDelete = useCallback(() => {
    onSubmit(selectedRows)
    close()
  }, [close, onSubmit, selectedRows])

  return (
    <Modal
      size='sm'
      className='delete-scenario-modal'
      open={open}
      onRequestClose={close}
      modalHeading={t('Scenario.DELETING_MODAL')}
      onRequestSubmit={onDelete}
      primaryButtonText={t('Scenario.DELETE')}
      secondaryButtonText={t('Common:Cancel')}
      confirmLoadingMessage={t('Common:Deleting')}
    >
      <h5>{confirmationMsg}</h5>
      {/* {!selectAll && (
        <div className='scenarios-ul'>
          {selectedRows.map(({ id, name }, idx) => (
            <p key={idx} className='scenarios-li'>
              {name}
            </p>
          ))}
        </div>
      )} */}
    </Modal>
  )
}

export default DeletingScenarioModal
